query checkMerkleProof($eth_address: String, $proof: JSON, $amount: String) {
    checkMerkleProof(eth_address: $eth_address, proof: $proof, amount: $amount) 
}
